import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { Archive16Regular, Delete16Regular, Pin20Regular } from '@/components/Icon'
import styles from './index.module.scss'

export default function AssistantMessageRetryMenu({
  retryMenuId,
  retryAnchorEl,
  retryOpen,
  onClose,
  onTryAgain,
  onThinkLonger,
  onSearchWeb,
}) {
  return (
    <Menu
      id={retryMenuId}
      anchorEl={retryAnchorEl}
      open={retryOpen}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: { elevation: 0, className: styles.retryMenuPaper },
        list: { dense: true, className: styles.retryMenuList },
      }}
    >
      <MenuItem onClick={() => { onClose(); onTryAgain?.() }} className={styles.menuItemCompact}>
        <ListItemIcon className={styles.menuItemIconWrap}>
          <Pin20Regular className={styles.menuItemIcon} aria-hidden />
        </ListItemIcon>
        <ListItemText primary="Try again" primaryTypographyProps={{ className: styles.menuItemLabel }} />
      </MenuItem>
      <MenuItem onClick={() => { onClose(); onThinkLonger?.() }} className={styles.menuItemCompact}>
        <ListItemIcon className={styles.menuItemIconWrap}>
          <Archive16Regular className={styles.menuItemIcon} aria-hidden />
        </ListItemIcon>
        <ListItemText primary="Think longer" primaryTypographyProps={{ className: styles.menuItemLabel }} />
      </MenuItem>
      <MenuItem onClick={() => { onClose(); onSearchWeb?.() }} className={styles.menuItemCompact}>
        <ListItemIcon className={styles.menuItemIconWrap}>
          <Delete16Regular className={styles.menuItemIcon} aria-hidden />
        </ListItemIcon>
        <ListItemText primary="Search web" primaryTypographyProps={{ className: styles.menuItemLabel }} />
      </MenuItem>
    </Menu>
  )
}
